import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

export function useDeepEffect(
  fn: () => void | (() => void),
  deps: any[],
  enableLogging: boolean = false,
): void {
  const isFirst = useRef(true);
  const prevDeps = useRef<any[]>([]);

  useEffect(() => {
    const isFirstEffect = isFirst.current;
    const changedDeps: { index: number; prev: any; current: any }[] = [];

    if (!isFirstEffect) {
      deps.forEach((dep, index) => {
        if (!isEqual(dep, prevDeps.current[index])) {
          changedDeps.push({
            index,
            prev: prevDeps.current[index],
            current: dep,
          });
        }
      });
    }

    isFirst.current = false;
    prevDeps.current = deps;

    if (isFirstEffect || changedDeps.length > 0) {
      if (
        import.meta.env.MODE === 'development' &&
        enableLogging &&
        changedDeps?.length > 0
      ) {
        console.groupCollapsed(
          '%c useDeepEffect: Changes detected',
          'color: blue; font-weight: bold;',
        );
        changedDeps?.forEach(({ index, prev, current }) => {
          console.log(
            `%cDependency[${index}] changed:`,
            'color: green; font-weight: bold;',
          );
          console.log(`Previous Value:`, prev);
          console.log(`Current Value:`, current);
        });
        console.groupEnd();
      }
      return fn();
    }
  }, deps);
}

export default useDeepEffect;
